// character master
export const CHARACTER_MASTER = "/master/character";
export const CHARACTER_MASTER_ADD = "/master/character/add";
export const CHARACTER_MASTER_EDIT = "/master/character/edit";

// pattern master
export const PATTERN_MASTER = "/master/pattern";
export const PATTERN_MASTER_ADD = "/master/pattern/add";
export const PATTERN_MASTER_EDIT = "/master/pattern/edit";

// Barcode
export const BARCODE = "/series-product/barcode";
export const BARCODE_ADD = "/series-product/barcode/add";
export const BARCODE_EDIT = "/series-product/barcode/edit/:id";
export const barcodeEditRoute = (id) => `/series-product/barcode/edit/${id}`;

// Chroma Collection
export const CHROMA_COLLECTION = "/series-product/chroma-collection";
export const CHROMA_COLLECTION_ADD = "/series-product/chroma-collection/add";
export const CHROMA_COLLECTION_EDIT =
  "/series-product/chroma-collection/edit/:id";
export const chromaCollectionEditRoute = (id) =>
  `/series-product/chroma-collection/edit/${id}`;

// Chroma Composite
export const CHROMA_COMPOSITE = "/series-product/chroma-composite";
export const CHROMA_COMPOSITE_ADD = "/series-product/chroma-composite/add";
export const CHROMA_COMPOSITE_EDIT =
  "/series-product/chroma-composite/edit/:id";
export const chromaCompositeEditRoute = (id) =>
  `/series-product/chroma-composite/edit/${id}`;

// Chroma Ribbed
export const CHROMA_RIBBED = "/series-product/chroma-ribbed";
export const CHROMA_RIBBED_ADD = "/series-product/chroma-ribbed/add";
export const CHROMA_RIBBED_EDIT = "/series-product/chroma-ribbed/edit/:id";
export const chromaRibbedEditRoute = (id) =>
  `/series-product/chroma-ribbed/edit/${id}`;

// Bunito
export const BUNITO = "/series-product/bunito";
export const BUNITO_ADD = "/series-product/bunito/add";
export const BUNITO_EDIT = "/series-product/bunito/edit/:id";
export const bunitoEditRoute = (id) => `/series-product/bunito/edit/${id}`;

// Mattle
export const MATTLE = "/series-product/mattle";
export const MATTLE_ADD = "/series-product/mattle/add";
export const MATTLE_EDIT = "/series-product/mattle/edit/:id";
export const mattleEditRoute = (id) => `/series-product/mattle/edit/${id}`;

// Canvas
export const CANVAS = "/series-product/canvas";
export const CANVAS_ADD = "/series-product/canvas/add";
export const CANVAS_EDIT = "/series-product/canvas/edit/:id";
export const canvasEditRoute = (id) => `/series-product/canvas/edit/${id}`;

// Novel
export const NOVEL = "/series-product/novel";
export const NOVEL_ADD = "/series-product/novel/add";
export const NOVEL_EDIT = "/series-product/novel/edit/:id";
export const novelEditRoute = (id) => `/series-product/novel/edit/${id}`;

// Marvel
export const MARVEL = "/series-product/marvel";
export const MARVEL_ADD = "/series-product/marvel/add";
export const MARVEL_EDIT = "/series-product/marvel/edit/:id";
export const marvelEditRoute = (id) => `/series-product/marvel/edit/${id}`;

// Reganto Deziner
export const REGANTO_DEZINER = "/series-product/reganto-deziner";
export const REGANTO_DEZINER_ADD = "/series-product/reganto-deziner/add";
export const REGANTO_DEZINER_EDIT = "/series-product/reganto-deziner/edit/:id";
export const regantoDezinerEditRoute = (id) =>
  `/series-product/reganto-deziner/edit/${id}`;

// Reganto Classic
export const REGANTO_CLASSIC = "/series-product/reganto-classic";
export const REGANTO_CLASSIC_ADD = "/series-product/reganto-classic/add";
export const REGANTO_CLASSIC_EDIT = "/series-product/reganto-classic/edit/:id";
export const regantoClassicEditRoute = (id) =>
  `/series-product/reganto-classic/edit/${id}`;

// Reganto Premier
export const REGANTO_PREMIER = "/series-product/reganto-premier";
export const REGANTO_PREMIER_ADD = "/series-product/reganto-premier/add";
export const REGANTO_PREMIER_EDIT = "/series-product/reganto-premier/edit/:id";
export const regantoPremierEditRoute = (id) =>
  `/series-product/reganto-premier/edit/${id}`;

// ACCO
export const ACCO = "/series-product/acco";
export const ACCO_ADD = "/series-product/acco/add";
export const ACCO_EDIT = "/series-product/acco/edit/:id";
export const accoEditRoute = (id) => `/series-product/acco/edit/${id}`;

// Furrow
export const FURROW = "/series-product/furrow";
export const FURROW_ADD = "/series-product/furrow/add";
export const FURROW_EDIT = "/series-product/furrow/edit/:id";
export const furrowEditRoute = (id) => `/series-product/furrow/edit/${id}`;

// Furrow Lite
export const FURROW_LITE = "/series-product/furrow-lite";
export const FURROW_LITE_ADD = "/series-product/furrow-lite/add";
export const FURROW_LITE_EDIT = "/series-product/furrow-lite/edit/:id";
export const furrowLiteEditRoute = (id) =>
  `/series-product/furrow-lite/edit/${id}`;

// Furrow Reganto
export const FURROW_REGANTO = "/series-product/furrow-reganto";
export const FURROW_REGANTO_ADD = "/series-product/furrow-reganto/add";
export const FURROW_REGANTO_EDIT = "/series-product/furrow-reganto/edit/:id";
export const furrowRegantoEditRoute = (id) =>
  `/series-product/furrow-reganto/edit/${id}`;

// process master
export const PROCESS_MASTER = "/master/process";
export const PROCESS_MASTER_ADD = "/master/process/add";
export const PROCESS_MASTER_EDIT = "/master/process/edit";

// colour master
export const COLOUR_MASTER = "/master/colour";
export const COLOUR_MASTER_ADD = "/master/colour/add";
export const COLOUR_MASTER_EDIT = "/master/colour/edit";

// Transporter master
export const TRANSPORTER_MASTER = "/master/transporter";
export const TRANSPORTER_MASTER_ADD = "/master/transporter/add";
export const TRANSPORTER_MASTER_EDIT = "/master/transporter/edit";

// Vehicle master
export const VEHICLE_MASTER = "/master/vehicle";
export const VEHICLE_MASTER_ADD = "/master/vehicle/add";
export const VEHICLE_MASTER_EDIT = "/master/vehicle/edit";

// Dispatch Address master
export const DISPATCH_ADDRESS_MASTER = "/master/dispatch-address";
export const DISPATCH_ADDRESS_MASTER_ADD = "/master/dispatch-address/add";
export const DISPATCH_ADDRESS_MASTER_EDIT = "/master/dispatch-address/edit";

// Photo master
export const PHOTO_MASTER = "/master/photo";
export const PHOTO_MASTER_ADD = "/master/photo/add";
export const PHOTO_MASTER_EDIT = "/master/photo/edit";
export const PHOTO_MASTER_VIEW_DETAILS = "/master/photo/viewDetails";

// Polish master
export const POLISH_MASTER = "/master/polish";
export const POLISH_MASTER_ADD = "/master/polish/add";
export const POLISH_MASTER_EDIT = "/master/polish/edit";
export const POLISH_MASTER_VIEW_DETAILS = "/master/polish/viewDetails";

// Customer master
export const CUSTOMER_MASTER = "/master/customer";
export const CUSTOMER_MASTER_VIEW = "/master/customer/view";
export const CUSTOMER_MASTER_ADD = "/master/customer/add";
export const CUSTOMER_MASTER_EDIT = "/master/customer/edit/:id";
export const customerMasterEditRoute = (id) => `/master/customer/edit/${id}`;

// -------------------------------Factory----------------------------------

export const CROSSCUT_FACTORY_ISSUE_ORDER = "/factory/cutting/issue-raw-order";
export const FLITCHING_FACTORY_ISSUE_ORDER =
  "/factory/flitching/issue-raw-order";
export const DRESSING_FACTORY_ISSUE_ORDER = "/factory/dressing/issue-raw-order";
export const PEELING_FACTORY = "/factory/peeling";
export const PEELING_FACTORY_ADD = "/factory/peeling/add";
export const PEELING_FLITCH_FACTORY_ADD = "/factory/peeling/flitch/add";
export const PEELING_FLITCH_FACTORY_EDIT = "/factory/peeling/flitch/edit/:id";
export const PEELING_FACTORY_EDIT = "/factory/peeling/edit/:id";
export const peelingFactoryEditRoute = (id) => `/factory/peeling/edit/${id}`;
export const peelingFlitchFactoryEditRoute = (id) =>
  `/factory/peeling/flitch/edit/${id}`;

// export const PEELING_FACTORY_LIST =
//   "/factory/peeling-approval/view-details/:id/:issue_for_peeling_id";
// Slicing Factory
export const FACTORY_SLICING = "/factory/slicing";
export const FACTORY_SLICING_ADD = "/factory/add-slicing";
export const FACTORY_SLICING_EDIT = "/factory/edit-slicing";
export const FACTORY_RE_SLICING_ADD = "/factory/re-slicing";

// Factory Grouping
export const FACTORY_GROUPING = "/factory/grouping";
export const FACTORY_GROUPING_ADD = "/factory/grouping/add";
export const FACTORY_GROUPING_EDIT = "/factory/grouping/edit/:id";
export const factoryGroupingEditRoute = (id) => `/factory/grouping/edit/${id}`;
export const FACTORY_REGROUPING_ADD = "/factory/grouping/re-grouping-add";
export const GROUPING_FACTORY_ISSUE_ORDER = "/factory/grouping/issue-order";

// Dressing Factory
export const FACTORY_DRESSING = "/factory/dressing";
export const FACTORY_DRESSING_ADD = "/factory/add-dressing";
export const FACTORY_DRESSING_EDIT = "/factory/edit-dressing";
export const FACTORY_RE_DRESSING_ADD = "/factory/re-dressing";

// Smoking Dying Factory
export const FACTORY_SMOKING_DYING = "/factory/smoking-dying";
export const FACTORY_SMOKING_DYING_ADD = "/factory/smoking-dying/add";
export const FACTORY_SMOKING_DYING_EDIT = "/factory/smoking-dying/edit/:id";
export const smokingDyingFactoryEditRoute = (id) =>
  `/factory/smoking-dying/edit/${id}`;

// Tapping Factory
export const FACTORY_TAPPING = "/factory/factory-tapping";
export const FACTORY_TAPPING_ADD = "/factory/factory-tapping/add";
export const FACTORY_TAPPING_EDIT = "/factory/factory-tapping/edit/:id";
export const tappingFactoryEditRoute = (id) =>
  `/factory/factory-tapping/edit/${id}`;

// Pressing Factory
export const FACTORY_PRESSING = "/factory/factory-pressing";
export const FACTORY_PRESSING_ADD = "/factory/factory-pressing/add";
export const FACTORY_PRESSING_EDIT = "/factory/factory-pressing/edit/:id";
export const factoryPressingEditRoute = (id) =>
  `/factory/factory-pressing/edit/${id}`;

// CNC Factory
export const FACTORY_CNC = "/factory/factory-cnc";
export const FACTORY_CNC_ADD = "/factory/factory-cnc/add";

// Colour Factory
export const FACTORY_COLOUR = "/factory/factory-colour";
export const FACTORY_COLOUR_ADD = "/factory/factory-colour/add";

// Bunito Factory
export const FACTORY_BUNITO = "/factory/factory-bunito";
export const FACTORY_BUNITO_ADD = "/factory/factory-bunito/add";

// Canvas Factory
export const FACTORY_CANVAS = "/factory/factory-canvas";
export const FACTORY_CANVAS_ADD = "/factory/factory-canvas/add";

// Polishing Factory
export const FACTORY_POLISHING = "/factory/factory-polishing";
export const FACTORY_POLISHING_ADD = "/factory/factory-polishing/add";

// ACCO Factory
export const FACTORY_ACCO = "/factory/factory-acco";

// Plywood Production Factory
export const FACTORY_PLYWOOD_PRODUCTION = "/factory/factory-plywood-production";
export const FACTORY_CREATE_PLYWOOD_PRODUCTION =
  "/factory/create-plywood-production";
export const FACTORY_EDIT_PLYWOOD_PRODUCTION =
  "/factory/edit-plywood-production/:id";
export const editPlywoodProductionRoute = (id) =>
  `/factory/edit-plywood-production/${id}`;

// Re-Sizing Plywood Factory
export const FACTORY_RE_SIZING_PLYWOOD = "/factory/factory-re-sizing-plywood";
export const FACTORY_RE_SIZING_PLYWOOD_ADD = "/factory/factory-re-sizing-plywood/add";
export const FACTORY_RE_SIZING_PLYWOOD_EDIT = "/factory/factory-re-sizing-plywood/edit/:id";
export const reSizingPlywoodFactoryEditRoute = (id) => `/factory/factory-re-sizing-plywood/edit/${id}`;

// Order
export const ORDER_ROUTE = "/order";
export const CREATE_RAW_ORDER = "/order/create-raw-order";
export const EDIT_RAW_ORDER = "/order/edit-raw-order/:id";
export const rawOrderEditRoute = (id) => `/order/edit-raw-order/${id}`;
export const CREATE_SERIES_PRODUCT_ORDER = "/order/create-series-product-order";
export const EDIT_SERIES_PRODUCT_ORDER = "/order/edit-series-product-order/:id";
export const seriesProductOrderEditRoute = (id) =>
  `/order/edit-series-product-order/${id}`;
export const CREATE_DECORATIVE_ORDER = "/order/create-decorative-order";
export const EDIT_DECORATIVE_ORDER = "/order/edit-decorative-order/:id";
export const editDecorativeOrderEditRoute = (id) =>
  `/order/edit-decorative-order/${id}`;
export const RAW_APPROVAL_VIEW_ROUTE = "/order/raw-approval/view/:id";
export const getRawApprovalViewRoute = (id) =>`/order/raw-approval/view/${id}`; 
export const DECORATIVE_APPROVAL_VIEW_ROUTE = "/order/decorative-approval/view/:id";
export const getDecorativeApprovalViewRoute = (id) =>`/order/decorative-approval/view/${id}`;
export const SERIES_PRODUCT_APPROVAL_VIEW_ROUTE = "/order/series-product-approval/view/:id";
export const getSeriesProductApprovalViewRoute = (id) =>`/order/series-product-approval/view/${id}`;


// Packing
export const PACKING_ROUTE = "/packing";
export const PACKING_ADD_ROUTE_RAW = "/packing/add/raw";
export const PACKING_ADD_ROUTE_FINISHED = "/packing/add/finished";
export const PACKING_EDIT_RAW_ROUTE = "/packing/edit/raw"
export const PACKING_APPROVAL_VIEW_DETAILS_ROUTE = "/packing/approval/view-details"
export const PACKING_EDIT_FINISHED_ROUTE = "/packing/edit/finished"
export const PACKING_VIEW_ROUTE = "packing/view";

// Dispatch
export const DISPATCH_ROUTE = "/dispatch";
export const DISPATCH_ADD_ROUTE = "/dispatch/add";
export const DISPATCH_APPROVAL_ROUTE = "/dispatch/approval";
export const DISPATCH_VIEW_ROUTE = "/dispatch/view";
export const DISPATCH_EDIT_ROUTE = "/dispatch/edit/:id";
export const DISPATCH_APPROVAL_VIEW_ROUTE = "/dispatch/approvalView";
export const dispatchEditRoute = (id) => `/dispatch/edit/${id}`;

// Challan
export const CHALLAN_ROUTE = "/challan";
export const CHALLAN_ADD_ROUTE = "/challan/add";
export const CHALLAN_VIEW_ROUTE = "/challan/view";
export const CHALLAN_EDIT_ROUTE = "/challan/edit/:id";
export const challanEditRoute = (id) => `/challan/edit/${id}`;

// Inventory
export const LOG_INVENTORY_ISSUE_ORDER = "/inventory/log/issue-order";
export const FLITCH_INVENTORY_ISSUE_ORDER = "/inventory/flitch/issue-order";
export const PLYWOOD_RAW_ORDER = "/inventory/plywood/issue-raw-order";
export const MDF_RAW_ORDER = "/inventory/mdf/issue-raw-order";
export const FACE_RAW_ORDER = "/inventory/face/issue-raw-order";
export const VENEER_INVENTORY_ISSUE_ORDER = "/inventory/veneer/issue-raw-order";
export const CORE_RAW_ORDER = "/inventory/core/issue-raw-order";
export const FLEECE_RAW_ORDER = "/inventory/fleece/issue-raw-order";
export const OTHER_GOODS_RAW_ORDER = "/inventory/other-goods/issue-raw-order";
